import React from 'react';
import ReactEcharts from 'echarts-for-react';
import { toEchartData } from './dataProcessor';
import formatter from './tooltipFormatter';
import SearchableChart from '../../../Searchable/Echarts/SearchableChart';
import responsive from '../../../Responsive';
import { MOBILE } from '../../../Responsive/responsiveIdentifier';

export function getOptions(chartData, theme) {
  const { data } = chartData;
  /**
   * mapeando cada legenda para uma entrada que possui
   * o nome da legenda e o ícone círculo.
   */
  // TODO: adicionar??
  // const legendData = legends.map((legend) => ({
  //   name: legend,
  //   icon: 'circle',
  // }));
  /**
   * criando um conjunto de series.
   *
   * Cada serie criada representará uma barra no gráfico.
   * Esta abordagem é necessária, pois no echarts, cada legenda remete a uma série.
   */
  const series = data.map((item, index) => {
    const dataEntry = new Array(data.length);
    dataEntry[(data.length - 1) - index] = item;
    return {
      name: item.name,
      type: 'bar',
      data: dataEntry,
      stack: 'stack',
      label: {
        formatter: (params) => `${params.data.value}%`,
        textStyle: {
          color: theme.label.text,
        },
      },
      itemStyle: item.itemStyle,
    };
  });

  return {
    color: theme.colors,
    // visibleLegends: legendData, TODO: legendas
    grid: {
      left: '2%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    label: {
      show: true,
      position: 'right',
    },
    tooltip: {
      show: true,
      trigger: 'item',
      formatter,
    },
    legend: {
      // data: legendData,
      type: 'scroll',
      textStyle: {
        color: theme.legend.color,
      },
      pageTextStyle: {
        color: theme.legend.pagination.text.color,
      },
      pageIconColor: theme.legend.pagination.buttons.color,
    },
    yAxis: {
      type: 'category',
      // data: legends.reverse(),
      // no modo vertical (padrão) os dados da linha y
      // não são exibidos
      axisTick: {
        show: false,
      },
      axisLabel: {
        show: false,
      },
    },
    xAxis: {
      type: 'value',
      axisLabel: {
        textStyle: {
          color: theme.axis.x.label,
        },
      },
      axisLine: {
        lineStyle: {
          color: theme.axis.x.line,
        },
      },
      boundaryGap: true,
    },
    series,
  };
}

class BarChart extends SearchableChart {
  onChartReady(echarts) {
    this.echarts = echarts;
  }

  /**
   * recupera as legends da instancia do echarts
   */
  getCurrentLegends() {
    const options = this.echarts.getOption();
    return options.visibleLegends;
  }

  /**
   * atualiza as legends em exibição do echarts.
   */
  updateLegends(newLegends) {
    const options = this.echarts.getOption();

    const legends = options.legend[0];
    legends.data = newLegends;

    const newOptions = {
      ...options,
      legend: legends,
    };
    this.updateOptions(newOptions, this.echarts);
  }

  /**
   * atualiza as configuracoes da instancia de echarts
   * passada.
   */
  // eslint-disable-next-line class-methods-use-this
  updateOptions(newOptions, chart) {
    chart.setOption(newOptions);
  }

  // const echartData = { data: [], legends: [] }; // toEchartData(data);
  // const echartData = toEchartData(data);
  // const options = getOptions(echartData, theme);
  render() {
    const { resolution, theme, data } = this.props;
    const options = toEchartData(data, theme);
    const isMobile = resolution === MOBILE;
    // const adaptedOptions = isMobile
    //   ? adaptToResponsive(options, echartData, theme)
    //   : options;
    const adaptedOptions = options;
    return (
      <ReactEcharts
        isMobile
        notMerge
        ref={(r) => { this.chartRef = r; }}
        option={adaptedOptions}
        onChartReady={(echarts) => this.onChartReady(echarts)}
        style={{ height: '165px', minHeight: '165px' }} // TODO: export to style
      />
    );
  }
}

export default responsive(BarChart);
